// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 540px) {
  .menu ion-icon {
    font-size: 10vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 7vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  .faq {
    background-color: #f0f6f9;
    background-image: url('bridge.svg');
    background-position: top center;
    background-repeat: repeat-y;
    background-size: 50%;
  }
  .faq h1 {
    font-size: 8vw;
    color: #292822;
    font-family: "Otomanopee One", sans-serif;
    margin-top: 10vw;
    text-align: center;
  }
  .faq p {
    font-size: 4vw;
    color: #5e5d59;
    line-height: 28px;
    text-align: center;
  }
  .accordion {
    background-color: white;
    margin-bottom: 4vw;
    border: 1px solid #e3e3e3;
  }
  .accordionHeader {
    background-color: white;
    overflow: hidden;
  }
  .accordionHeader h1 {
    margin: 0px;
    padding: 4vw;
    font-size: 5vw;
    width: 100%;
    float: left;
    text-align: left;
  }
  .accordionHeader a {
    float: right;
  }
  .accordionBody p {
    margin: 0px;
    padding-top: 2vw;
    padding-bottom: 4vw;
    padding-left: 4vw;
    padding-right: 4vw;
    font-size: 4vw;
    width: 100%;
  }
}
@media (min-width: 720px) {
  .menu ion-icon {
    font-size: 8vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 4vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  .faq {
    background-color: #f0f6f9;
    background-image: url('bridge.svg');
    background-position: top center;
    background-repeat: repeat-y;
    background-size: 50%;
  }
  .faq h1 {
    font-size: 8vw;
    color: #292822;
    font-family: "Otomanopee One", sans-serif;
    margin-top: 10vw;
    text-align: center;
  }
  .faq p {
    font-size: 4vw;
    color: #5e5d59;
    line-height: 28px;
    text-align: center;
  }
  .accordion {
    background-color: white;
    margin-bottom: 4vw;
    border: 1px solid #e3e3e3;
  }
  .accordionHeader {
    background-color: white;
    overflow: hidden;
  }
  .accordionHeader h1 {
    margin: 0px;
    padding: 4vw;
    font-size: 5vw;
    width: 100%;
    float: left;
    text-align: left;
  }
  .accordionHeader a {
    float: right;
  }
  .accordionBody p {
    margin: 0px;
    padding-top: 2vw;
    padding-bottom: 4vw;
    padding-left: 4vw;
    padding-right: 4vw;
    width: 100%;
    font-size: 3vw;
    text-align: left;
    line-height: 3.5vw;
  }
}
@media (min-width: 960px) {
  .logo {
    width: 133px;
    height: 72px;
    background-image: url('logo.svg');
    background-size: 100%;
  }
  .menu ion-icon {
    font-size: 2vw;
    cursor: pointer;
    color: #414042;
  }
  h1 {
    font-size: 2vw;
    font-family: "Otomanopee One", sans-serif;
    color: #292822;
    text-align: left;
  }
  .faq {
    background-color: #f0f6f9;
    background-image: url('bridge.svg');
    background-position: top center;
    background-repeat: repeat-y;
  }
  .faq h1 {
    font-size: 3vw;
    color: #292822;
    font-family: "Otomanopee One", sans-serif;
    margin-top: 5vw;
  }
  .faq p {
    font-size: 1vw;
    color: #5e5d59;
  }
  .accordion {
    background-color: white;
    margin-bottom: 1vw;
    border: 1px solid #e3e3e3;
  }
  .accordionHeader {
    background-color: white;
    overflow: hidden;
  }
  .accordionHeader h1 {
    margin: 0px;
    padding: 1vw;
    font-size: 1.5vw;
    width: 100%;
    float: left;
  }
  .accordionHeader a {
    float: right;
  }
  .accordionBody p {
    margin: 0px;
    padding-top: 0.5vw;
    padding-bottom: 1vw;
    padding-left: 1vw;
    padding-right: 1vw;
    font-size: 1vw;
    width: 100%;
    line-height: 1.2vw;
  }
}
.bg {
  background-image: url('student-bg.svg');
  background-repeat: no-repeat;
  background-color: #f0f6f9;
  background-position-y: bottom;
  padding-bottom: 5vw;
}

ion-content {
  --ion-background-color: #fff;
}

.content {
  background-color: white;
  background-image: url('student-bg-bottom.svg');
  background-repeat: no-repeat;
  background-position: center bottom;
  border-top-left-radius: 1vw;
  border-top-right-radius: 1vw;
  margin-top: -1vw;
  min-height: 100vh;
}

.toDoListTitle {
  color: #0038a8;
  font-family: "Otomanopee One", sans-serif;
}

.ion-padding-bottom {
  padding-bottom: 200px;
}

.backCaption {
  text-decoration: none;
  cursor: pointer;
}

.reloadBtn {
  text-decoration: none;
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/student/module-progress-quiz/module-progress-quiz.page.scss"],"names":[],"mappings":"AAAA;EACE;IACE,eAAA;IACA,eAAA;IACA,cAAA;EACF;EACA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EACF;EAEA;IACE,yBAAA;IACA,mCAAA;IACA,+BAAA;IACA,2BAAA;IACA,oBAAA;EAAF;EAGA;IACE,cAAA;IACA,cAAA;IACA,yCAAA;IACA,gBAAA;IACA,kBAAA;EADF;EAIA;IACE,cAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EAFF;EAKA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;EAHF;EAMA;IACE,uBAAA;IACA,gBAAA;EAJF;EAOA;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;EALF;EAQA;IACE,YAAA;EANF;EASA;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;EAPF;AACF;AAUA;EACE;IACE,cAAA;IACA,eAAA;IACA,cAAA;EARF;EAUA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EARF;EAWA;IACE,yBAAA;IACA,mCAAA;IACA,+BAAA;IACA,2BAAA;IACA,oBAAA;EATF;EAYA;IACE,cAAA;IACA,cAAA;IACA,yCAAA;IACA,gBAAA;IACA,kBAAA;EAVF;EAaA;IACE,cAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EAXF;EAcA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;EAZF;EAeA;IACE,uBAAA;IACA,gBAAA;EAbF;EAgBA;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;EAdF;EAiBA;IACE,YAAA;EAfF;EAkBA;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;EAhBF;AACF;AAmBA;EACE;IACE,YAAA;IACA,YAAA;IACA,iCAAA;IACA,qBAAA;EAjBF;EAoBA;IACE,cAAA;IACA,eAAA;IACA,cAAA;EAlBF;EAoBA;IACE,cAAA;IACA,yCAAA;IACA,cAAA;IACA,gBAAA;EAlBF;EAqBA;IACE,yBAAA;IACA,mCAAA;IACA,+BAAA;IACA,2BAAA;EAnBF;EAsBA;IACE,cAAA;IACA,cAAA;IACA,yCAAA;IACA,eAAA;EApBF;EAuBA;IACE,cAAA;IACA,cAAA;EArBF;EAwBA;IACE,uBAAA;IACA,kBAAA;IACA,yBAAA;EAtBF;EAyBA;IACE,uBAAA;IACA,gBAAA;EAvBF;EA0BA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;EAxBF;EA2BA;IACE,YAAA;EAzBF;EA4BA;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;EA1BF;AACF;AA4BA;EACE,uCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;AA1BF;;AA6BA;EACE,4BAAA;AA1BF;;AA4BA;EACE,uBAAA;EACA,8CAAA;EACA,4BAAA;EACA,kCAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,yCAAA;AAzBF;;AA4BA;EACE,qBAAA;AAzBF;;AA4BA;EACE,qBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,qBAAA;EACA,YAAA;AAzBF","sourcesContent":["@media (max-width: 540px) {\r\n  .menu ion-icon {\r\n    font-size: 10vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 7vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n\r\n  .faq {\r\n    background-color: #f0f6f9;\r\n    background-image: url(\"../../../../assets/img/layout/bridge.svg\");\r\n    background-position: top center;\r\n    background-repeat: repeat-y;\r\n    background-size: 50%;\r\n  }\r\n\r\n  .faq h1 {\r\n    font-size: 8vw;\r\n    color: #292822;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    margin-top: 10vw;\r\n    text-align: center;\r\n  }\r\n\r\n  .faq p {\r\n    font-size: 4vw;\r\n    color: #5e5d59;\r\n    line-height: 28px;\r\n    text-align: center;\r\n  }\r\n\r\n  .accordion {\r\n    background-color: white;\r\n    margin-bottom: 4vw;\r\n    border: 1px solid #e3e3e3;\r\n  }\r\n\r\n  .accordionHeader {\r\n    background-color: white;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .accordionHeader h1 {\r\n    margin: 0px;\r\n    padding: 4vw;\r\n    font-size: 5vw;\r\n    width: 100%;\r\n    float: left;\r\n    text-align: left;\r\n  }\r\n\r\n  .accordionHeader a {\r\n    float: right;\r\n  }\r\n\r\n  .accordionBody p {\r\n    margin: 0px;\r\n    padding-top: 2vw;\r\n    padding-bottom: 4vw;\r\n    padding-left: 4vw;\r\n    padding-right: 4vw;\r\n    font-size: 4vw;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 720px) {\r\n  .menu ion-icon {\r\n    font-size: 8vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 4vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n\r\n  .faq {\r\n    background-color: #f0f6f9;\r\n    background-image: url(\"../../../../assets/img/layout/bridge.svg\");\r\n    background-position: top center;\r\n    background-repeat: repeat-y;\r\n    background-size: 50%;\r\n  }\r\n\r\n  .faq h1 {\r\n    font-size: 8vw;\r\n    color: #292822;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    margin-top: 10vw;\r\n    text-align: center;\r\n  }\r\n\r\n  .faq p {\r\n    font-size: 4vw;\r\n    color: #5e5d59;\r\n    line-height: 28px;\r\n    text-align: center;\r\n  }\r\n\r\n  .accordion {\r\n    background-color: white;\r\n    margin-bottom: 4vw;\r\n    border: 1px solid #e3e3e3;\r\n  }\r\n\r\n  .accordionHeader {\r\n    background-color: white;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .accordionHeader h1 {\r\n    margin: 0px;\r\n    padding: 4vw;\r\n    font-size: 5vw;\r\n    width: 100%;\r\n    float: left;\r\n    text-align: left;\r\n  }\r\n\r\n  .accordionHeader a {\r\n    float: right;\r\n  }\r\n\r\n  .accordionBody p {\r\n    margin: 0px;\r\n    padding-top: 2vw;\r\n    padding-bottom: 4vw;\r\n    padding-left: 4vw;\r\n    padding-right: 4vw;\r\n    width: 100%;\r\n    font-size: 3vw;\r\n    text-align: left;\r\n    line-height: 3.5vw;\r\n  }\r\n}\r\n\r\n@media (min-width: 960px) {\r\n  .logo {\r\n    width: 133px;\r\n    height: 72px;\r\n    background-image: url(\"../../../../assets/img/layout/logo.svg\");\r\n    background-size: 100%;\r\n  }\r\n\r\n  .menu ion-icon {\r\n    font-size: 2vw;\r\n    cursor: pointer;\r\n    color: #414042;\r\n  }\r\n  h1 {\r\n    font-size: 2vw;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    color: #292822;\r\n    text-align: left;\r\n  }\r\n\r\n  .faq {\r\n    background-color: #f0f6f9;\r\n    background-image: url(\"../../../../assets/img/layout/bridge.svg\");\r\n    background-position: top center;\r\n    background-repeat: repeat-y;\r\n  }\r\n\r\n  .faq h1 {\r\n    font-size: 3vw;\r\n    color: #292822;\r\n    font-family: \"Otomanopee One\", sans-serif;\r\n    margin-top: 5vw;\r\n  }\r\n\r\n  .faq p {\r\n    font-size: 1vw;\r\n    color: #5e5d59;\r\n  }\r\n\r\n  .accordion {\r\n    background-color: white;\r\n    margin-bottom: 1vw;\r\n    border: 1px solid #e3e3e3;\r\n  }\r\n\r\n  .accordionHeader {\r\n    background-color: white;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .accordionHeader h1 {\r\n    margin: 0px;\r\n    padding: 1vw;\r\n    font-size: 1.5vw;\r\n    width: 100%;\r\n    float: left;\r\n  }\r\n\r\n  .accordionHeader a {\r\n    float: right;\r\n  }\r\n\r\n  .accordionBody p {\r\n    margin: 0px;\r\n    padding-top: 0.5vw;\r\n    padding-bottom: 1vw;\r\n    padding-left: 1vw;\r\n    padding-right: 1vw;\r\n    font-size: 1vw;\r\n    width: 100%;\r\n    line-height: 1.2vw;\r\n  }\r\n}\r\n.bg {\r\n  background-image: url(\"../../../../assets/img/layout/student-bg.svg\");\r\n  background-repeat: no-repeat;\r\n  background-color: #f0f6f9;\r\n  background-position-y: bottom;\r\n  padding-bottom: 5vw;\r\n}\r\n\r\nion-content {\r\n  --ion-background-color: #fff;\r\n}\r\n.content {\r\n  background-color: white;\r\n  background-image: url(\"../../../../assets/img/layout/student-bg-bottom.svg\");\r\n  background-repeat: no-repeat;\r\n  background-position: center bottom;\r\n  border-top-left-radius: 1vw;\r\n  border-top-right-radius: 1vw;\r\n  margin-top: -1vw;\r\n  min-height: 100vh;\r\n}\r\n\r\n.toDoListTitle {\r\n  color: #0038a8;\r\n  font-family: \"Otomanopee One\", sans-serif;\r\n}\r\n\r\n.ion-padding-bottom {\r\n  padding-bottom: 200px;\r\n}\r\n\r\n.backCaption {\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.reloadBtn {\r\n  text-decoration: none;\r\n  float: right;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
